import { render, staticRenderFns } from "./societeProfil.vue?vue&type=template&id=92ebb906"
import script from "./societeProfil.vue?vue&type=script&lang=js"
export * from "./societeProfil.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports